export default {
	setSlackValue:0
}